import styled from 'styled-components';
import { CFBaseTextStyles, } from '@connectrn/ds-ui-base';
export const CFTextElementTags = {
    Body: 'p',
    Body2: 'p',
    Body2Bold: 'b',
    Body2Semibold: 'b',
    BodyBold: 'b',
    BodyCallout: 'p',
    BodyLarge: 'p',
    BodyLargeBold: 'b',
    BodyLargeSemibold: 'b',
    BodySemibold: 'b',
    Micro: 'p',
    MicroBold: 'b',
    MicroSemibold: 'b',
    Subtitle1: 'p',
    Subtitle2: 'p',
    Subtitle3: 'p',
    Title1: 'h1',
    Title2: 'h2',
    Title3: 'h3',
    Title4: 'h4',
    Title5: 'h5',
    Title6: 'h6',
};
export const CFTextElements = {
    Root: styled.p `
    ${CFBaseTextStyles.RootWeb}
    ${CFBaseTextStyles.Root}
  `,
    RootWrapper: styled.div `
    ${CFBaseTextStyles.RootWrapper}
  `,
};
